import axios from 'axios'
import { setupCache } from 'axios-cache-adapter'

const cache = setupCache({
  maxAge: 60 * 60 * 1000,
  exclude: {
    query: false,
  },
})

const axiosInstance = axios.create({
  baseURL: process.env.MIX_API_URL,
  adapter: cache.adapter,
})

const sessionKey = 'jetfly_api_session'
let session = window.sessionStorage.getItem(sessionKey)

if (!session) {
  session = crypto.randomUUID()
  window.sessionStorage.setItem(sessionKey, session)
}

// Set API session ID.
axiosInstance.defaults.headers.common['X-JETFLY-API-SESSION-ID'] = session

export default axiosInstance

export const queryLocations = (query) => {
  return axiosInstance.get(`/fractional/locations?query=${query}`)
}

export const getAirports = (placeId, page = 1, limit = 3) => {
  return axiosInstance.get(`/fractional/places/${placeId}/airports?limit=${limit}&page=${page}`)
}

export const getAirport = (icao) => {
  return axiosInstance.get(`/fractional/airports/${icao}`)
}

export const getGeoIP = () => {
  return axiosInstance.get('/geoip')
}

export const getPlaceCoordinates = (placeId) => {
  return axiosInstance.get(`/fractional/places/${placeId}`)
}

export const getFlightEstimate = (departureCode, arrivalCode) => {
  const payload = { departure_airport: departureCode, arrival_airport: arrivalCode }
  return axiosInstance.post('/fractional/estimates', payload)
}
